import { NavLink, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AppHeader } from './AppHeader';
import { MobileBottomNav } from './MobileBottomNav';
import { SiteFooter } from '../components/SiteFooter';
import { MAIN_NAV } from './navigation';

export function AppLayout() {
  const { pathname } = useLocation();
  const isWideContent =
    pathname.startsWith('/board') || pathname.startsWith('/account');

  return (
    <Shell>
      <SkipLink href="#main-content">본문으로 바로가기</SkipLink>
      <AppHeader
        nav={
          <DesktopNav aria-label="주요 메뉴">
            {MAIN_NAV.map(({ to, label, Icon }) => (
              <StyledNavLink key={to} to={to} end={to === '/board'}>
                <Icon size={16} />
                {label}
              </StyledNavLink>
            ))}
          </DesktopNav>
        }
      />
      <Content id="main-content" tabIndex={-1} $wide={isWideContent}>
        <Outlet />
      </Content>
      <SiteFooter $withMobileNav />
      <MobileBottomNav />
    </Shell>
  );
}

const Shell = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
`;

const SkipLink = styled.a`
  position: fixed;
  top: 8px;
  left: 16px;
  z-index: 2000;
  transform: translateY(-160%);
  padding: 10px 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  &:focus { transform: translateY(0); }
`;

const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 20px;
  min-width: 0;

  @media (max-width: 900px) {
    display: none;
  }
`;

const StyledNavLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.textSecondary};
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryHover};
    background: ${({ theme }) => theme.colors.primarySoft};
  }

  &.active {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primarySoft};
  }
`;

const Content = styled.main<{ $wide?: boolean }>`
  flex: 1;
  width: 100%;
  max-width: ${({ $wide }) => ($wide ? '1320px' : '1200px')};
  margin: 0 auto;
  padding: 32px 28px 56px;

  @media (max-width: 900px) {
    padding: 24px 20px 40px;
  }

  @media (max-width: 768px) {
    padding: 24px 16px 32px;
  }
`;
